export function canRecoverProductIndex(permissions: string[] = []): boolean {
  return (
    permissions.includes('**:w') ||
    permissions.includes('productIndexRecovery:w')
  )
}

export function recoveryTarget(productId: unknown, channelId: unknown) {
  const product = Number(productId)
  const channel = Number(channelId)
  if (
    !Number.isSafeInteger(product) ||
    product <= 0 ||
    !Number.isSafeInteger(channel) ||
    channel <= 0
  ) {
    throw new Error('Choose a channel and enter a positive product ID.')
  }
  return { productId: product, channelId: channel }
}
